import React from "react";
import arrowLeft from "../assets/images/arrow-left.svg";
import useAppStore from "../stores/useAppStore";
import IconButton from "./IconButton";

function FlipButton() {

    const isRightHanded = useAppStore(state => state.isRightHanded);

    return (
        <IconButton
            text={isRightHanded ? "Flip to left handed view" : "Flip to right handed view"}
            icon={
                <img src={arrowLeft}
                     width={18}
                     alt="arrow"
                     style={{rotate: isRightHanded ? "0deg" : "180deg"}}
                />
            }
            onClick={() => useAppStore.setState({isRightHanded: !isRightHanded})}
        />
    );
}

export default FlipButton;